<template>
    <div v-if="isVisible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div class="text-neutral text-center  mb-4">
                <p v-if="beforeMessage" v-html="beforeMessage" class="text-center text-neutral-content" />
                <p v-html="message" class="mt-4 text-left "></p>

                <p class="mt-4 text-center text-neutral-content">
                    {{ $t("confirmWindow.subtext") }}
                </p>
            </div>
            <div class="flex justify-center mt-4">
                <MyButton variant="primary" classes="mx-2" :value="$t('confirmWindow.btn')" @click.native="confirm" />
                <MyButton variant="error" classes="mx-2" :value="$t('confirmWindow.btnCancel')" @click.native="cancel" />
            </div>
        </div>
    </div>
</template>

<script>
import MyButton from "../ui/button.vue";

export default {
    name: "ConfirmWindow",
    components: {
        MyButton
    },
    data() {
        return {
            isVisible: false,
            message: "",
            beforeMessage: "",
            resolvePromise: null,
            rejectPromise: null
        };
    },
    methods: {
        show(msg, beforeMsg) {
            this.message = msg;
            this.beforeMessage = beforeMsg;
            this.isVisible = true;

            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
                this.rejectPromise = reject;
            });
        },
        confirm() {
            this.isVisible = false;
            this.$emit("confirm");
            if (this.resolvePromise) {
                this.resolvePromise();
            }
        },
        cancel() {
            this.isVisible = false;
            this.$emit("cancel");
            if (this.rejectPromise) {
                this.rejectPromise(new Error("Cancelled by user"));
            }
            this.resolvePromise = null;
            this.rejectPromise = null;
        }
    }
};
</script>
